module.exports = __webpack_public_path__ + "img/u30917.c4356c5e.png";